/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Close_Aria_LabelInputs */

const en_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_desktop_banner_close_aria_label = /** @type {(inputs: Desktop_Banner_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Desktop_Banner_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_close_aria_label = /** @type {((inputs?: Desktop_Banner_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_desktop_banner_close_aria_label(inputs)
	if (locale === "de") return de_desktop_banner_close_aria_label(inputs)
	if (locale === "it") return it_desktop_banner_close_aria_label(inputs)
	if (locale === "ru") return ru_desktop_banner_close_aria_label(inputs)
	if (locale === "es") return es_desktop_banner_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_desktop_banner_close_aria_label(inputs)
	if (locale === "ja") return ja_desktop_banner_close_aria_label(inputs)
	if (locale === "hi") return hi_desktop_banner_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_desktop_banner_close_aria_label(inputs)
	return en_desktop_banner_close_aria_label(inputs)
});